var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_promise-resolve.js
// module id = ./node_modules/core-js/modules/_promise-resolve.js
// module chunks = 1